// auto-generated by Typewriter template _enums.tst from PortCall.Models\PortCall\BerthReservation.cs
export enum BerthReservationStatus { 
    Requested = 0,
    Booked = 1,
    Cancelled = 2,
    Conflicted = 3
}

export const BerthReservationStatusDisplayName : { [val : number] : string } = { 
    0: 'Requested',
    1: 'Booked',
    2: 'Cancelled',
    3: 'Conflicted'
}

export const BerthReservationStatuses : { Id : BerthReservationStatus, Name : string }[] = [ 
    { Id: BerthReservationStatus.Requested, Name: 'Requested' },
    { Id: BerthReservationStatus.Booked, Name: 'Booked' },
    { Id: BerthReservationStatus.Cancelled, Name: 'Cancelled' },
    { Id: BerthReservationStatus.Conflicted, Name: 'Conflicted' }
]

export enum VesselSide { 
    Starboard = 0,
    Port = 10,
    SternTo = 20,
    TBD = 30
}

export const VesselSideDisplayName : { [val : number] : string } = { 
    0: 'Starboard side-to',
    10: 'Port side-to',
    20: 'Stern to',
    30: 'TBD'
}

export const VesselSides : { Id : VesselSide, Name : string }[] = [ 
    { Id: VesselSide.Starboard, Name: 'Starboard side-to' },
    { Id: VesselSide.Port, Name: 'Port side-to' },
    { Id: VesselSide.SternTo, Name: 'Stern to' },
    { Id: VesselSide.TBD, Name: 'TBD' }
]



// WEBPACK FOOTER //
// ./server/enums/BerthReservation.ts